import { Theme, css } from '@emotion/react';

export const root = (theme: Theme) => css`
  align-items: flex-start;
  margin-left: -8px;

  & .MuiFormControlLabel-label {
    padding-top: 10px; /* 40 (control height) - 20 (label height) /2 */
  }
`;

export const small = (theme: Theme) => css`
  & .MuiFormControlLabel-label {
    padding-top: 8px; /* 36 (control height) - 20 (label height) /2 */
  }
`;

export const labelPlacementStart = (theme: Theme) => css`
  margin-right: -8px;
`;

export const label = (theme: Theme) => css`
  line-height: 1.25; /* body01Medium, todo - share with typography styles, mixin? */
`;
